import { Suspense } from 'react';
import { RouterProvider } from 'react-router-dom';
import { ChakraProvider } from '@chakra-ui/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { useWatchAppHeight } from '@izimi/hooks';
import theme from '@izimi/theme';

import { router } from './Router';
import '@izimi/components/src/tracking/cookies/styles.css';
import '@izimi/components/src/DatePicker/chakra-react-datepicker.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
});

const App = () => {
  useWatchAppHeight();

  return (
    <Suspense>
      <QueryClientProvider client={queryClient}>
        <ChakraProvider theme={theme}>
          <RouterProvider router={router} />
        </ChakraProvider>
      </QueryClientProvider>
    </Suspense>
  );
};

export default App;
